(() => {
  if (window.cavryneCartFixInitialized) return;
  window.cavryneCartFixInitialized = true;

  const getProductScope = (form) =>
    form?.closest('[id^="MainProduct-"]') ||
    form?.closest('.shopify-section') ||
    document;

  window.cavryneSyncProductVariant = (form) => {
    if (!form) return false;
    const scope = getProductScope(form);
    const picker = scope.querySelector('variant-selects');
    if (!picker) return false;

    const jsonNode = picker.querySelector('script[type="application/json"]');
    if (!jsonNode) return false;

    let variants;
    try { variants = JSON.parse(jsonNode.textContent || '[]'); }
    catch (_) { return false; }
    if (!Array.isArray(variants) || !variants.length) return false;

    const groups = Array.from(picker.querySelectorAll('.product-form__input'));
    const selectedOptions = [];
    for (const group of groups) {
      const selectedRadio = group.querySelector('input[type="radio"]:checked');
      const select = group.querySelector('select');
      const selected = selectedRadio || select;
      if (!selected) continue;
      selectedOptions.push(String(selected.value));
    }
    if (!selectedOptions.length) return false;

    const match = variants.find((variant) => {
      const options = Array.isArray(variant.options)
        ? variant.options.map(String)
        : [variant.option1, variant.option2, variant.option3].filter((v) => v != null).map(String);
      return options.length === selectedOptions.length &&
        options.every((value, index) => value === selectedOptions[index]);
    });
    if (!match || !match.id) return false;

    const idInput = form.querySelector('[name="id"]');
    if (!idInput) return false;
    idInput.value = String(match.id);
    return true;
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('variant-selects')) return;
    const scope = event.target.closest('[id^="MainProduct-"]') || event.target.closest('.shopify-section') || document;
    scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach((form) => {
      window.cavryneSyncProductVariant(form);
    });
  }, true);

  async function refreshAndOpenDrawer() {
    const cartUrl = window.routes?.cart_url || '/cart';
    const rootUrl = cartUrl.replace(/cart\/?(?:\?.*)?$/, '');
    const sectionUrl = `${rootUrl || '/'}?sections=cart-drawer`;
    const response = await fetch(sectionUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Unable to refresh cart drawer');
    const sections = await response.json();
    const html = sections && sections['cart-drawer'];
    if (!html) throw new Error('Cart drawer section was not returned');

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const freshSection = parsed.querySelector('#shopify-section-cart-drawer');
    const currentSection = document.querySelector('#shopify-section-cart-drawer');
    if (freshSection && currentSection) currentSection.replaceWith(freshSection);

    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    } else if (drawer) {
      drawer.classList.add('active');
      drawer.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
    } else {
      throw new Error('Cart drawer is not present in the theme');
    }

    document.dispatchEvent(new CustomEvent('cavryne:cart-updated'));
  }

  // Open the theme's existing right-side drawer when the header cart icon is clicked.
  // Do not intercept cart links inside the drawer itself.
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const cartLink = event.target.closest('a#cart-icon-bubble, a.header__icon--cart');
    if (!cartLink || cartLink.closest('cart-drawer')) return;
    if (!document.querySelector('cart-drawer')) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    try {
      await refreshAndOpenDrawer();
    } catch (error) {
      console.error('[Cavryne cart drawer]', error);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (drawer) {
        drawer.classList.add('active');
        drawer.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }
    }
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[data-type="add-to-cart-form"]')) return;
    if (form.dataset.cavryneAjaxPending === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;
    window.cavryneSyncProductVariant(form);

    const submitter = event.submitter instanceof HTMLButtonElement ? event.submitter : form.querySelector('[name="add"]');
    if (submitter?.disabled) return;
    const originalText = submitter?.innerHTML;
    form.dataset.cavryneAjaxPending = 'true';
    if (submitter) {
      submitter.disabled = true;
      submitter.setAttribute('aria-busy', 'true');
    }

    try {
      const formData = new FormData(form);
      const id = formData.get('id');
      if (!id) throw new Error('Nie można ustalić wybranego wariantu produktu. Wybierz pakiet ponownie.');

      const action = form.getAttribute('action') || window.routes?.cart_add_url || '/cart/add';
      const addUrl = action.endsWith('.js') ? action : `${action.replace(/\/$/, '')}.js`;
      const addResponse = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      const result = await addResponse.json();
      if (!addResponse.ok) throw new Error(result.description || result.message || 'Nie udało się dodać produktu do koszyka.');

      await refreshAndOpenDrawer();
    } catch (error) {
      console.error('[Cavryne cart]', error);
      const message = error?.message || 'Wystąpił błąd. Odśwież stronę i spróbuj ponownie.';
      let errorBox = form.querySelector('[data-hurevani-cod-error]') || form.querySelector('.product-form__error-message');
      if (!errorBox) {
        errorBox = document.createElement('p');
        errorBox.className = 'cavryne-cart-error';
        errorBox.setAttribute('role', 'alert');
        form.appendChild(errorBox);
      }
      errorBox.textContent = message;
      errorBox.hidden = false;
      if (!document.querySelector('cart-drawer')) {
        window.location.assign(window.routes?.cart_url || '/cart');
      }
    } finally {
      form.dataset.cavryneAjaxPending = 'false';
      if (submitter) {
        submitter.disabled = false;
        submitter.removeAttribute('aria-busy');
        if (originalText) submitter.innerHTML = originalText;
      }
    }
  }, true);
})();
